export default "__VITE_ASSET__c5ff249b__"